import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';


import LearnerProgrammesList from '../../Components/LearnerProgrammesList';

import ThinkToolPopup from '../../Components/Popups/ThinkToolPopup';

import InviteDeclineReasonPopup from '../../Components/Popups/InviteDeclineReasonPopup';


import { commonStyles } from '../../styles/styles';
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn, MDBAnimation} from "mdbreact";


import UserCard from '../../Components/Cards/UserCard';
import ChangeProfilePopup from '../../Components/Popups/ChangeProfilePopup';

const LearnerView = ({ classes, view, showProfile }) => (
  
  
    <div className={classes.mainBackground}>
      <MDBRow className="m-0">
          <MDBCol lg="3" md="4" sm="5"><UserCard/></MDBCol>
          <MDBCol lg="9" md="8" sm="7"><LearnerProgrammesList/></MDBCol>
      </MDBRow>
  
      {view.declineInviteReasonPopup && <InviteDeclineReasonPopup />}
     
    </div>
   
    

);

const styles = () => ({
  ...commonStyles,
  userListColumn: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    maxWidth: 267,
    zIndex:1000,
  },
  toolsColumn: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 0,
    position: 'relative',
    flexDirection: 'column',
    left:-10,
    maxWidth: 230,
    zIndex:900,
  },
  dashboardColumn: {
    display: 'flex',
    flex: 5,
    paddingBottom:5
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    height:'100%',
    paddingBottom:10,
    alignItems: 'stretch',
    overflow: 'auto',
    backgroundColor: '#e8e8e8'
  }
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  showProfile: state.userProgramsFullReducer.showProfile,
});


export default compose(
 
  withStyles(styles)
  )(LearnerView);

LearnerView.propTypes = {
  classes: PropTypes.instanceOf(Object),
  view: PropTypes.instanceOf(Object),
};
